// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"styles_sectionTitle__t9HnL","title":"styles_title__cr_cJ","description":"styles_description__q_jfU"};